export default "__VITE_ASSET__62b60df5__"